import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Moment from 'moment';
import MentionableTextArea from '@Common/MentionableTextArea/MentionableTextArea';
import { DATE_FORMAT } from '@Constants/constants';
import { CommentDetailsProps, MentionableUser } from './Types';
import Icon from '@Components/Common/Icon';

interface CommentRowProps {
    comment: CommentDetailsProps;
    mentionableUsers: MentionableUser[];
    onCommentPost: (commentId: number, value: string) => Promise<any>;
}

const CommentRow = (props: CommentRowProps) => {

    const { mentionableUsers, onCommentPost } = props;

    const [isEditable, setIsEditable] = useState<boolean>(false);
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [comment, setComment] = useState<CommentDetailsProps>(props.comment);
    const [commentContent, setCommentContent] = useState<string>(comment.commentHtml);

    const currentUserId = useSelector((state: { user: { id: number } }) => state.user.id);

    useEffect(() => {
        // Editable within 5 minutes and only by the same user
        setIsEditable(Moment.utc().diff(comment.created) < 1000 * 60 * 5 && props.comment.modifiedBy === currentUserId.toString());
        setCommentContent(comment.commentHtml);
    }, [comment.created, comment.commentHtml]);

    const onModifyCommentSave = async () => {
        const newComment = await onCommentPost(comment.id, commentContent);
        setComment(newComment);
        setIsEditing(false);
    }

    const cancelModify = () => {
        setIsEditing(false);
        setCommentContent(comment.commentHtml);
    }

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='bg-light comment-row'>
                    {isEditing
                        ? <>
                            <div className='edit-comment-container w-100'>
                                <MentionableTextArea
                                    name='comment'
                                    data={mentionableUsers}
                                    value={commentContent}
                                    onChange={(e) => setCommentContent(e.target.value)}
                                    maxLength={2000}
                                    placeHolder='What would you like to say? Type @ to tag a user in your comment.'
                                />
                                <div className='buttons-container'>
                                    <button type='button' title='Save' className='pacer-table-button post-button' onClick={onModifyCommentSave}>
                                        <i className='far fa-circle-check'></i>
                                    </button>
                                    <button type='button' title='Cancel' className='pacer-table-button post-button' onClick={cancelModify}>
                                        <i className='far fa-circle-xmark'></i>
                                    </button>
                                </div>
                            </div>
                        </>
                        : <div className='d-flex flex-column'>
                            <span className="comment-rendered text-break" dangerouslySetInnerHTML={{ __html: commentContent }}></span>

                            <span className='comment-footer mt-2'>
                                {comment.createdBy} | {Moment.utc(comment.created).format(DATE_FORMAT)}
                                {isEditable && !isEditing && <>
                                    <button type='button' title='Edit' className='btn btn-link' onClick={() => setIsEditing((prev) => !prev)}>
                                        <Icon name="pencil-alt" />
                                    </button>
                                </>}
                            </span>
                            {Moment(comment.created).diff(comment.modified) < 0 &&
                                <span className='comment-footer mt-2'>Edited by {comment.modifiedBy} | {Moment.utc(comment.modified).format(DATE_FORMAT)}</span>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default CommentRow;